module.exports = __webpack_public_path__ + "img/10.385cc89b.jpg";